import { useEffect, useState } from 'react'
import classNames from 'classnames'

import styles from './MediaPlayer.module.scss'

function MediaPlayer({
  src = '',
  type = 'video/mp4',
  errorText = 'Your browser does not support the video tag.',
  className,
  preload = 'metadata',
  mute,
  play,
  videoClass,
}) {
  const [source, setSource] = useState(src)
  const [muted, setMuted] = useState(mute)

  useEffect(() => {
    setSource(src)
    setMuted(mute)
  }, [src, mute])

  return (
    <div className={classNames(styles.videoContainer, className)}>
      <video
        className={classNames(styles.video, videoClass)}
        width="100%"
        src={source}
        preload={preload}
        muted={muted}
        controls={true}
        autoPlay
        controlsList={
          'play timeline volume nodownload noplaybackrate noremoteplayback'
        }
        playsInline
      >
        {/* <source src={source} type={type} /> */}
        {errorText}
      </video>
    </div>
  )
}

export default MediaPlayer
